<nb-card accent="success">
  <nb-card-header>
    <div class="p-grid p-jc-between detail-title">
      <div class="col-md-2">
        <button pButton pRipple type="button" icon="pi pi-angle-left" (click)="navigateBack()"
          class="p-button-rounded p-button-secondary p-button-text p-button-lg"></button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body *ngIf="product && !hasError">
    <div class="row">
      <div class="col-md-4">
        <div class="product-item">
          <div class="product-item-content">

            <p-carousel [value]="product.links" [autoplayInterval]="5000" [circular]="product.links.length > 1"
              [responsiveOptions]="responsiveOptions">
              <ng-template ngbSlide let-item pTemplate="item" class="image-item">
                <img [src]="item" alt="" class="product-image" (dblclick)="imgDetail()">
              </ng-template>
            </p-carousel>

          </div>
        </div>
      </div>
      <div class="col-md-8 product-list-action">
        <div class="p-d-flex p-flex-column">
          <div class="p-mt-6 product-name">
            {{ getProductName() | titlecase }}
          </div>
          <div *ngIf="selectedMeasurementUnit" class="mt-3">
            <discount-info [selectedMeasurementUnit]="selectedMeasurementUnit" [indexPrice]="selectedMeasurementUnit.indexPrice" [measurementQuantity]="selectedMeasurementUnit.quantity" [product]="product"></discount-info>
          </div>
          <div *ngIf="selectedMeasurementUnit" class="p-mt-3 product-price">
            <span class="product-price">
              {{ (product.offerPrice != 0 ? product.offerPrice : product.price) * selectedMeasurementUnit.quantity *
              selectedMeasurementUnit.indexPrice | currency:'BRL' }}
              <span *ngIf="selectedMeasurementUnit.quantity > 1" class="product-price aux">
                ( {{ ((product.offerPrice != 0 ? product.offerPrice : product.price) * selectedMeasurementUnit.quantity
                * selectedMeasurementUnit.indexPrice) / selectedMeasurementUnit.quantity | currency:'BRL' }})</span>
            </span>
          </div>
          <div class="p-d-flex">
            <div class="btn-group" *ngFor="let measurement of product.measurementUnits">
              <button class="btn-measurement" id="btnradio_{{ measurement.id }}"
                (click)="selectMeasurement(measurement, $event)"
                [ngClass]="{'unitSelected': measurement.id === selectedMeasurementUnit.id}">
                {{ measurement.description }}
              </button>
            </div>
          </div>
          <div *ngIf="product.quantity != null">
            <p>
              Estoque: {{ product.quantity }}
            </p>
          </div>
        </div>
        <div class="value-details">
          <div class="unit-price">
            <custom-input-number [product]="productParam" (loadingEmitter)="changeLoading($event)"
              [loading]="this.loadingQuantity" [measurementUnit]="selectedMeasurementUnit"
              [styleConfig]="styleConfig"></custom-input-number>
          </div>
          <div class="item-flex p-d-flex p-flex-column">
            <label class="p-mb-2">Valor Total</label>
            <strong class="p-mb-2">{{ getTotal(product, selectedMeasurementUnit) | currency:'BRL' }}</strong>
          </div>
        </div>
      </div>
    </div>
    <p-card [style]="{'width': '100%', 'font-weight': 600, 'font-size': '1.2rem', 'box-shadow': 'initial'}">
      <h5 *ngIf="haveDetailToShow()">Detalhes do produto:</h5>
      <p>{{ productDetail() }}</p>

      <div *ngIf="haveInfoProductDetail()" class="row">
        <div *ngFor="let property of product.properties; let index = index" class="col-6 row product-property"
          [ngClass]="{'odd': (index % 4) === 0 || (index % 4) === 1}">
          <div class="col-4"><strong>{{property.name}}</strong></div>
          <div class="col-8">{{property.description}}</div>
        </div>
      </div>
    </p-card>
  </nb-card-body>
  <nb-card-body *ngIf="hasError">
    <div class="row col-12 justify-content-center">
      <div>
        <h2>Ops...</h2>
        <p>Não foi possível localizar o produto que você está procurando</p>
      </div>
    </div>
  </nb-card-body>
</nb-card>